<script setup lang="ts">
// One of an input's audio channels, picked: shown 1..count whatever the
// field stores (`base` 0: an encode's channel map; 1: an output's list).
const model = defineModel<number>({ required: true })
const props = withDefaults(defineProps<{ base?: 0 | 1; count?: number }>(), { base: 0, count: 16 })
const shown = (v: number) => v - props.base + 1
</script>

<template>
    <select v-model.number="model" class="w-auto font-mono tabular-nums">
        <option v-for="n in count" :key="n" :value="n - 1 + base">{{ n }}</option>
        <option v-if="model < base || shown(model) > count" :value="model">
            {{ shown(model) }} (not on the input)
        </option>
    </select>
</template>
